/* WANDRY cart: server-rendered content; one quantity mutation at a time. */
(function () {
  'use strict';
  if (window.WD_CART_CONTROLLER) return;
  window.WD_CART_CONTROLLER = true;
  var busy = false;
  function drawer() { return document.querySelector('cart-drawer'); }
  function cancel(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  function error(message, recover) {
    var target = document.getElementById('CartDrawer-CartErrors');
    if (target) {
      target.textContent = message;
      if (recover) {
        var link = document.createElement('a');
        link.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
        link.setAttribute('data-wd-cart-recovery', '');
        link.textContent = '장바구니를 확인하고 결제하기';
        link.style.cssText = 'display:block;text-decoration:underline;padding:12px 0';
        target.appendChild(link);
      }
    }
    var status=document.querySelector('.wd-upsell-status');if(status)status.textContent=message;
  }
  function lock(value) {
    busy = value;
    var cart = drawer();
    if (!cart) return;
    cart.classList.toggle('wd-cart-updating', value);
    cart.setAttribute('aria-busy', String(value));
    cart.querySelectorAll('button,input.quantity__input').forEach(function (el) {
      if (el.closest('.drawer__close')) return;
      if (value && !el.disabled) { el.dataset.wdDisabled = '1'; el.disabled = true; }
      else if (!value && el.dataset.wdDisabled) { el.disabled = false; delete el.dataset.wdDisabled; }
    });
  }
  // The carousel owns its scroll listeners; section replacement cleans them up.
  if(!customElements.get('wd-cart-carousel'))customElements.define('wd-cart-carousel',class extends HTMLElement{
    connectedCallback(){
      this.track=this.querySelector('.wd-upsell-slides');if(!this.track)return;
      this.onScroll=()=>this.refresh();this.track.addEventListener('scroll',this.onScroll,{passive:true});
      this.resize=new ResizeObserver(()=>this.refresh());this.resize.observe(this.track);this.refresh();
    }
    disconnectedCallback(){if(this.track)this.track.removeEventListener('scroll',this.onScroll);if(this.resize)this.resize.disconnect();}
    refresh(){
      if(!this.track)return;var width=this.track.clientWidth;if(!width)return;
      var index=Math.round(this.track.scrollLeft/width),slides=this.track.children;
      this.dataset.selected=slides[index]?.dataset.wdSlide||'';
      this.querySelectorAll('[data-wd-upsell-nav]').forEach(btn=>{
        var disabled=slides.length<2;
        if(busy){if(!disabled)btn.dataset.wdDisabled='1';else delete btn.dataset.wdDisabled;btn.disabled=true;}
        else btn.disabled=disabled;
      });
    }
    move(direction){if(!this.track)return;var width=this.track.clientWidth,index=Math.round(this.track.scrollLeft/width);this.track.scrollTo({left:((index+direction+this.track.children.length)%this.track.children.length)*width,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  });
  function updateInPlace(cart,state,addition){
    var doc=new DOMParser().parseFromString(state.sections['cart-drawer'],'text/html');
    var current=cart.querySelector('.cart-items'),next=doc.querySelector('.cart-items');
    if(!current||!next||state.item_count===0){
      cart.classList.toggle('is-empty',state.item_count===0);cart.renderContents(state,true);return;
    }
    var body=cart.querySelector('.cart-drawer__body'),top=body.scrollTop,edge=body.getBoundingClientRect().top;
    var anchor=Array.from(body.querySelectorAll('[data-wd-line-key],.wdp-forces,.wdp-expert')).find(el=>el.getBoundingClientRect().bottom>edge+1);
    var anchorOffset=anchor&&anchor.getBoundingClientRect().top;
    var anchorKey=anchor?.dataset.wdLineKey,anchorVariant=anchor?.dataset.wdVariantId;
    var anchorClass=anchor&&!anchorKey?(anchor.classList.contains('wdp-forces')?'.wdp-forces':'.wdp-expert'):null;
    var oldRows=Array.from(current.children),used=new Set();
    Array.from(next.children).forEach(fresh=>{
      var old=oldRows.find(el=>!used.has(el)&&el.dataset.wdLineKey===fresh.dataset.wdLineKey);
      // Stable nodes are retained; only changed server-rendered rows are replaced.
      if(old){used.add(old);var clean=old.cloneNode(true);clean.querySelectorAll('[data-wd-disabled]').forEach(el=>{el.removeAttribute('disabled');delete el.dataset.wdDisabled;});clean.querySelectorAll('.loading-overlay').forEach(el=>el.classList.add('hidden'));if(clean.outerHTML!==fresh.outerHTML){old.replaceWith(fresh);old=fresh;}current.appendChild(old);}
      else current.appendChild(fresh);
    });
    oldRows.forEach(el=>{if(!used.has(el))el.remove();});
    ['.drawer__heading','.wd-compact-total'].forEach(selector=>{
      var old=cart.querySelector(selector),fresh=doc.querySelector(selector);if(!old||!fresh)throw Error('장바구니 화면을 확인하지 못했어요.');old.innerHTML=fresh.innerHTML;
    });
    var carousel=cart.querySelector('wd-cart-carousel'),newCarousel=doc.querySelector('wd-cart-carousel');
    if(carousel&&newCarousel){
      var track=carousel.querySelector('.wd-upsell-slides'),chosen=carousel.dataset.selected||track.firstElementChild?.dataset.wdSlide;
      var freshSlides=Array.from(newCarousel.querySelector('.wd-upsell-slides').children),oldSlides=Array.from(track.children);
      freshSlides.forEach(fresh=>{var old=oldSlides.find(el=>el.dataset.wdSlide===fresh.dataset.wdSlide);track.appendChild(old||fresh);});
      oldSlides.forEach(el=>{if(!freshSlides.some(f=>f.dataset.wdSlide===el.dataset.wdSlide))el.remove();});
      var index=Array.from(track.children).findIndex(el=>el.dataset.wdSlide===chosen);track.scrollLeft=Math.max(0,index)*track.clientWidth;carousel.refresh();
    }
    cart.getSectionsToRender().filter(s=>s.id!=='cart-drawer').forEach(section=>{
      var target=document.getElementById(section.id);if(target&&section.selector)target=target.matches(section.selector)?target:target.querySelector(section.selector);
      if(target&&state.sections[section.id])target.innerHTML=cart.getSectionInnerHTML(state.sections[section.id],section.selector);
    });
    var items=cart.querySelector('cart-drawer-items');if(items)items.currentItemCount=state.item_count;
    var restored=anchorClass?body.querySelector(anchorClass):Array.from(body.querySelectorAll('[data-wd-line-key]')).find(el=>el.dataset.wdLineKey===anchorKey);
    if(!restored&&anchorVariant)restored=Array.from(body.querySelectorAll('[data-wd-line-key]')).find(el=>el.dataset.wdVariantId===anchorVariant);
    body.scrollTop=restored?top+restored.getBoundingClientRect().top-anchorOffset:top;
    var live=cart.querySelector('#CartDrawer-LiveRegionText');if(live)live.textContent=addition?'상품을 장바구니에 담았어요':'장바구니를 업데이트했어요';
  }

  async function change(row, quantity, focusName, addition) {
    if (busy || (!row && !addition) || !Number.isInteger(quantity) || quantity < 0) return;
    var key = row && row.dataset.wdLineKey;
    if (!key && !addition) return;
    var cart = drawer(), scroll = cart.querySelector('.cart-drawer__body');
    var top = scroll ? scroll.scrollTop : 0;
    var input = row && row.querySelector('.quantity__input');
    var previous = input && input.getAttribute('value');
    var sections = cart.getSectionsToRender().map(function (s) { return s.id; });
    lock(true); error('');
    var spinner = row && row.querySelector('.loading-overlay');
    if (spinner) spinner.classList.remove('hidden');
    var uncertain = true;
    try {
      var root = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
      var payload = addition ? {items:[addition]} : {id:key,quantity:quantity};
      payload.sections=sections; payload.sections_url=location.pathname;
      var response = await fetch(root+(addition?'cart/add.js':'cart/change.js'), {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify(payload)
      });
      var state = await response.json().catch(function(){return null;});
      if (!response.ok || (state && state.errors)) {
        uncertain = response.status >= 500;
        throw Error(response.status===429 ? '접속이 몰리고 있어요. 잠시 후 다시 시도해 주세요.' : (state && (state.description || state.errors) || '수량을 변경하지 못했어요.'));
      }
      if(!state)throw Error('장바구니 응답을 확인하지 못했어요.');
      if (addition) {
        var addedSections=state.sections;
        var cartResponse=await fetch(root+'cart.js',{cache:'no-store'});
        if(!cartResponse.ok) throw Error('장바구니를 확인하지 못했어요.');
        state=await cartResponse.json(); state.sections=addedSections;
      }
      if (!state.sections || sections.some(function (id) { return !state.sections[id]; })) {
        var fresh = await fetch(root+'?sections='+sections.join(','),{cache:'no-store'});
        if (!fresh.ok) throw Error('장바구니 화면을 업데이트하지 못했어요. 페이지를 새로고침해 주세요.');
        state.sections = await fresh.json();
        if (sections.some(function (id) { return !state.sections[id]; })) throw Error('장바구니 화면을 업데이트하지 못했어요. 페이지를 새로고침해 주세요.');
      }
      updateInPlace(cart,state,addition);
      uncertain = false;
      lock(false);
      if(addition){
        var addedButton=cart.querySelector(addition.id===45873190666375?'[data-wd-care-add]':('[data-wd-upsell-add="'+(addition.id===45873016799367?'guide':'deodorant')+'"]'));
        if(addedButton){addedButton.textContent='추가했어요 ✓';addedButton.dataset.wdAdded='1';addedButton.focus({preventScroll:true});}
        else {var status=cart.querySelector('.wd-upsell-status');if(status)status.textContent='W케어 정기배송을 추가했어요';}
      } else {
        var nextRow=Array.from(cart.querySelectorAll('[data-wd-line-key]')).find(function(el){return el.dataset.wdLineKey===key;});
        var focus=nextRow&&(focusName?nextRow.querySelector('button[name="'+focusName+'"]'):nextRow.querySelector('.quantity__input'));
        if(focus)focus.focus({preventScroll:true});
      }
      document.dispatchEvent(new CustomEvent('wandry:cart-updated',{detail:state}));
      document.dispatchEvent(new CustomEvent('cartQuantityUpdated',{detail:{handle:'wandry'}}));
    } catch (err) {
      if (!uncertain && input && previous !== null) input.value = previous;
      error(uncertain ? '연결이 끊겼어요. 이미 추가·변경되었을 수 있으니 장바구니를 확인해 주세요.' : (typeof err.message === 'string' ? err.message : '장바구니를 업데이트하지 못했어요. 다시 시도해 주세요.'), uncertain);
    } finally {
      if (spinner) spinner.classList.add('hidden');
      lock(uncertain);
    }
  }
  window.addEventListener('click', function (event) {
    var target = event.target.closest && event.target;
    if (!target) return;
    if (target.closest('[data-wd-cart-recovery]')) return;
    if (busy && target.closest('cart-drawer') && !target.closest('.drawer__close,#CartDrawer-Overlay')) { cancel(event); return; }
    if (busy && target.closest('a.common_button:not(.btn_scorall),.np-btn--primary,.np-xadd,.wd-xsell__add,[data-wa01-buy]')) { cancel(event); return; }
    var nav=target.closest('[data-wd-upsell-nav]');
    if(nav){cancel(event);var carousel=nav.closest('wd-cart-carousel');if(carousel)carousel.move(Number(nav.dataset.wdUpsellNav));return;}
    var upsell=target.closest('[data-wd-upsell-add]');
    if(upsell){cancel(event);var variants={guide:45873016799367,deodorant:45873016832135};var id=variants[upsell.dataset.wdUpsellAdd];if(id)change(null,1,null,{id:id,quantity:1});return;}
    if (target.closest('[data-wd-care-add]')) {
      cancel(event);
      change(null,1,null,{id:45873190666375,quantity:1,selling_plan:3754655879,properties:{'배송 내용':'유도 스프레이 30ml×1＋탈취 스프레이 100ml×1','배송 주기':'30일마다／2개 합계 49,900원'}});
      return;
    }
    var button = target.closest('cart-drawer .quantity__button,cart-drawer cart-remove-button button');
    if (!button) return;
    var row = button.closest('[data-wd-line-key]'), input = row && row.querySelector('.quantity__input');
    if (!row || !input) return;
    cancel(event);
    var quantity = button.closest('cart-remove-button') ? 0 : Number(input.value)+(button.name==='plus'?1:-1);
    if (input.max && quantity > Number(input.max)) return;
    change(row, Math.max(0,quantity), button.name);
  }, true);
  window.addEventListener('change', function (event) {
    if (!event.target.matches('cart-drawer .quantity__input')) return;
    cancel(event);
    if (busy) return;
    var input=event.target, quantity=Number(input.value);
    if (!Number.isInteger(quantity) || quantity < 0 || (input.max && quantity > Number(input.max))) {
      input.value=input.getAttribute('value'); return;
    }
    change(input.closest('[data-wd-line-key]'),quantity);
  }, true);
  window.addEventListener('submit', function (event) {
    if (busy && event.target.closest('cart-drawer')) cancel(event);
  }, true);
  // Preserve the existing logo destination; no page-wide observers or recurring timers.
  document.querySelectorAll('.header__heading-link').forEach(function (a) { a.href='/ko-kr/products/wandry'; });
})();
